// BF26 /bf pricing model. Pure functions, no DOM: used by the page for live prices,
// the ladder and the cart estimate, and by node tests. Amounts are piasters.
(function (root) {
  function tierFor(units, tiers) {
    var pct = 0;
    tiers.forEach(function (t) { if (units >= t.min) pct = t.pct; });
    return pct;
  }

  function nextTier(units, tiers) {
    for (var i = 0; i < tiers.length; i++) if (units < tiers[i].min) return tiers[i];
    return null;
  }

  // lines: [{ id, price, qty, tier: bool }]. One discount applies (they don't combine):
  // the tier % on tier products, or the gift book free. Shopify gives the larger one.
  function quote(lines, cfg) {
    var units = 0, tierSub = 0, sub = 0, giftQty = 0;
    lines.forEach(function (l) {
      sub += l.price * l.qty;
      if (l.tier) { units += l.qty; tierSub += l.price * l.qty; }
      if (l.id === cfg.gift.id) giftQty += l.qty;
    });
    var pct = tierFor(units, cfg.tiers);
    var tierSave = Math.round(tierSub * pct / 100);
    var giftPrice = giftQty ? lines.filter(function (l) { return l.id === cfg.gift.id; })[0].price : 0;
    var giftBasis = sub - giftPrice * giftQty;          // the rest of the order, full price
    var giftSave = giftQty && giftBasis > cfg.giftAbove ? giftPrice : 0;
    var applied = giftSave > tierSave ? 'gift' : (tierSave > 0 ? 'tier' : null);
    var save = Math.max(tierSave, giftSave);
    var total = sub - save;
    var shipping = lines.length === 0 ? 0 : (total > cfg.freeShippingAbove ? 0 : cfg.shippingFee);
    return { units: units, pct: pct, sub: sub, tierSave: tierSave, giftSave: giftSave, applied: applied,
             save: save, total: total, shipping: shipping, pay: total + shipping,
             toFreeShipping: Math.max(0, cfg.freeShippingAbove + 1 - total) };
  }

  // Would adding the gift book make it free (gift beats the tier)? Returns the extra cash, or null.
  function giftOffer(lines, cfg, giftPrice) {
    if (lines.some(function (l) { return l.id === cfg.gift.id; })) return null;
    var now = quote(lines, cfg);
    var withGift = quote(lines.concat([{ id: cfg.gift.id, price: giftPrice, qty: 1, tier: true }]), cfg);
    if (withGift.applied !== 'gift') return null;
    return { extra: withGift.total - now.total, giftPrice: giftPrice };
  }

  var api = { tierFor: tierFor, nextTier: nextTier, quote: quote, giftOffer: giftOffer };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.BFPricing = api;
})(this);
